const painPoints = [
  {
    num: '01',
    title: 'Hundreds of portals, one you',
    desc: 'Every town, city, and state agency posts bids on their own website, each source with its own format, login, and update schedule. Checking them all is a full-time job you don\'t have time for.',
  },
  {
    num: '02',
    title: 'Deadlines sneak up on you',
    desc: 'By the time you find a relevant bid, the pre-bid meeting has passed or the deadline is days away. You miss the window to price properly, gather subs, and submit a competitive proposal. Another job goes to someone else.',
  },
  {
    num: '03',
    title: 'Manual checking burns hours',
    desc: 'Most contractors spend 5-10 hours a week manually checking portals, sorting through irrelevant bids, and copying details into spreadsheets. That\'s 250-500 hours a year spent on work that doesn\'t win you a single job.',
  },
]

const portalWindows = [
  { rotate: '-6deg', x: -30, y: -20, label: 'MA Portal', pulse: true },
  { rotate: '4deg', x: 40, y: 10, label: 'CT Bids', pulse: false },
  { rotate: '-3deg', x: -20, y: 50, label: 'NH Gov', pulse: true },
  { rotate: '7deg', x: 50, y: -40, label: 'ME Towns', pulse: false },
  { rotate: '-5deg', x: -40, y: 30, label: 'RI State', pulse: false },
  { rotate: '2deg', x: 30, y: 60, label: 'VT Agency', pulse: true },
  { rotate: '-8deg', x: 10, y: -50, label: 'Lexington', pulse: false },
  { rotate: '5deg', x: -10, y: 40, label: 'Portland', pulse: false },
]

export default function ProblemSection() {
  return (
    <section
      id="problem"
      className="relative py-[clamp(80px,12vh,160px)] bg-[#0d1117]"
    >
      <div className="max-w-[1280px] mx-auto px-6">
        <div className="problem-header text-center mb-16">
          <span className="text-xs font-mono uppercase tracking-[0.08em] text-[#06b6d4]">
            THE PROBLEM
          </span>
          <h2 className="mt-4 text-[clamp(28px,3vw,42px)] font-semibold leading-[1.15] tracking-[-0.015em] text-white max-w-[700px] mx-auto">
            Bids are everywhere. Your attention isn't.
          </h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[55%_45%] gap-12 items-center">
          <div className="pain-points-container space-y-8">
            {painPoints.map((point) => (
              <div key={point.num} className="pain-point flex gap-5">
                <span className="text-[clamp(14px,1.2vw,18px)] font-mono font-medium text-[#06b6d4] tracking-[0.04em] shrink-0 pt-1">
                  {point.num}
                </span>
                <div>
                  <h3 className="text-[clamp(18px,2vw,24px)] font-semibold text-white leading-[1.3]">
                    {point.title}
                  </h3>
                  <p className="mt-2 text-base leading-[1.6] text-[#9ca3af]">
                    {point.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="portal-visual relative w-full aspect-square max-w-[400px] mx-auto">
            {portalWindows.map((win, i) => (
              <div
                key={i}
                className="portal-window absolute w-[140px] h-[100px] bg-[#1f2937] border border-white/10 rounded-md overflow-hidden"
                style={{
                  transform: `rotate(${win.rotate}) translate(${win.x}px, ${win.y}px)`,
                  left: `${20 + (i % 3) * 30}%`,
                  top: `${10 + Math.floor(i / 3) * 25}%`,
                }}
              >
                <div className="h-5 bg-[#1e293b] border-b border-white/5 flex items-center px-2 gap-1">
                  <div className="w-2 h-2 rounded-full bg-[#ef4444]/60" />
                  <div className="w-2 h-2 rounded-full bg-[#f59e0b]/60" />
                  <div className="w-2 h-2 rounded-full bg-[#10b981]/60" />
                </div>
                <div className="p-2">
                  <div className="text-[8px] font-mono text-[#9ca3af] uppercase">{win.label}</div>
                  <div className="mt-1 space-y-1">
                    <div className="h-1.5 bg-white/10 rounded w-3/4" />
                    <div className="h-1.5 bg-white/10 rounded w-1/2" />
                    <div className="h-1.5 bg-white/10 rounded w-2/3" />
                  </div>
                </div>
                {win.pulse && (
                  <div className="absolute bottom-2 right-2 w-2 h-2 rounded-full bg-[#06b6d4] animate-pulse-dot" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
